import TextButtonWithDocumentation from "./TextButtonDocumentation";
import React from "react";
import {withStyles, Menu, Button, MenuItem, Popover, Typography} from "@material-ui/core";
import {
  usePopupState,
  bindTrigger,
  bindPopover,
} from "material-ui-popup-state/hooks";
import PriceIntersectsFirstCandleDocs from "./PriceIntersectsFirstCandleDocumentation";
import EmaIntersectsFirstCandleDocs from "./EmaFirstCandleDocumentation";
import TimeOfDayDocumentation from "./TimeOfDayDocumentation";
import FtfcFilterDocs from "./FtfcFilterDocumentation";

export default function SetupFilterDocs() {
  const popupState = usePopupState({
    variant: "popover",
    popupId: "setupFilterMenu",
  });
  return (
    <>
      <Button {...bindTrigger(popupState)}><Typography style={{fontSize:12}} />docs</Button>
      <Popover
        {...bindPopover(popupState)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        &nbsp;&nbsp;&nbsp;&nbsp;docs:
        <TextButtonWithDocumentation
          label="Price_intersects_first_candle"
          doc={PriceIntersectsFirstCandleDocs}
        />
        <TextButtonWithDocumentation
          label="ema_intersects_first_candle"
          doc={EmaIntersectsFirstCandleDocs}
        />
          <TextButtonWithDocumentation
              label="time_of_day"
              doc={TimeOfDayDocumentation}
          />
          <TextButtonWithDocumentation
              label="ftfc"
              doc={FtfcFilterDocs}
          />
      </Popover>
    </>
  );
}
